import { addDays, differenceInMilliseconds, getDay, startOfDay } from 'date-fns'

/**
 * Calculates the number of days until the next occurrence of a specific day at a specific hour (UTC).
 * @param date The current date.
 * @param targetDay The target day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday).
 * @param targetHour The hour (UTC) on the target day to calculate until.
 * @returns The number of days until the next occurrence of the target day at the specified hour.
 */
export const getDaysUntilNextTarget = (date: Date, targetDay: number, targetHour: number): number => {
    const currentDay = getDay(date) // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const daysUntilTarget = (7 + targetDay - currentDay) % 7 || 7 // Calculate days until the target day
    const nextTargetDay = addDays(startOfDay(date), daysUntilTarget) // Get the start of the target day
    const nextTargetAtTargetHourUTC = new Date(nextTargetDay.getTime() + targetHour * 60 * 60 * 1000) // Add targetHour to the target day's start
    const now = new Date()

    // Calculate the difference in days
    const differenceInMs = differenceInMilliseconds(nextTargetAtTargetHourUTC, now)
    return Math.ceil(differenceInMs / (1000 * 60 * 60 * 24)) // Convert milliseconds to days
}
